import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import {Provider} from "mobx-react";
import {BrowserRouter} from "react-router-dom";
import App from "./App";
import {InitializedStores} from "./stores/initializeStores";
import {Amplify} from "aws-amplify";

// @ts-ignore
Amplify.configure(window.$AWS_CONFIG);

ReactDOM.render(
    <Provider {...InitializedStores}>
        <BrowserRouter /*basename={'/#'}*/>
            <App/>
        </BrowserRouter>
    </Provider>, document.getElementById('root'));
// ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
